<template>
  <module-list-layout :createAction="createAction" :module="module" v-if="amReady">
    <el-dialog :visible.sync="dialogVisible" title="" top="5vh" width="75%" custom-class="el-custom-dialog">
      <moduleForm
          :autoBind="false"
          :formHeader="true"
          :edit-mode="editMode"
          :bindingForView="true"
          :dataToBind="dataToBind"
          :on-edit-callback="afterEdit"
          :on-create-callback="afterCreate"
          :moduleDeleteAction='moduleFormDeleteAction'
          :formTitle="((editMode)? 'Update ' : 'Create ') + module.info.caption"
          v-if="dialogVisible"></moduleForm>
    </el-dialog>

    <div class="row">
      <div class="col-12 col-md-6 px-4">
        <dg-text-field
            class="mt-2"
            :field_span="12"
            :label_span="2"
            field_mark=""
            :translateLabel="false"
            label="Search"
            placeholder="search here"
            @amUpdated="userSearchUpdated"
            :liveUpdate="true"></dg-text-field>
      </div>
      <div class="col-12 col-md-6">
        <span style="display: inline-block;margin-right: 20px;">
              <el-tag type="success">Records: {{ recordsCounter }}</el-tag> <small>24 record per page</small>
        </span>
        <pagination
            class="mt-1"
            :currentPage="currentPage"
            paginateClass=""
            :page-count="Math.ceil(recordsCounter / pageChunkSize)"
            :page-range="4"
            :margin-pages="2"
            :navigateHandler="navigateToPage"></pagination>
      </div>
    </div>

    <el-table
        :data="tableData"
        border
        cell-class-name="p-1"
        stripe
        style="width: 100%">
      <el-table-column type="expand">
        <template slot-scope="props">

          <!--row-class-name="app-light-silver-background"-->
          <h6 class="app-light-silver-background m-0 p-2 pl-3 text-center">Fusion Info</h6>
          <el-table
              :data="[props.row]"
              border
              cell-class-name="p-1"
              header-cell-class-name="app-light-silver-background p-1"
              style="width: 100%;">
            <el-table-column
                label="Url"
                prop="url"
                width="200">
              <template slot-scope="scope">
                <vlink :text="setTableFusionServerProp(scope.row.id, 'url')"
                       :url="setTableFusionServerProp(scope.row.id, 'url')"></vlink>
              </template>
            </el-table-column>
            <el-table-column
                :formatter="setTableFusionServerFormatter"
                label="Password"
                prop="password"
                width="350">
              <template slot-scope="scope">
                <smartInputView :customParams="{id: setTableFusionServerProp(scope.row.id, 'id')}"
                                :inputValue="setTableFusionServerProp(scope.row.id, 'password')"
                                :saveAction="updateFusionField"
                                editContainerStyle="position: relative;top: 0px;" fieldName="password"
                                inputWidth="200px"></smartInputView>
              </template>
            </el-table-column>
            <el-table-column label="VOS"
                             prop=""
                             v-if="props.row.user_profile_id == 5 || props.row.user_profile_id == 6">
              <template slot-scope="scope">
                {{ setTableVOSServerProp(scope.row.id, 'vos_recharge_link') }}
              </template>
            </el-table-column>
            <el-table-column
                :formatter="setTableFusionServerFormatter"
                label="Name"
                prop="name">
            </el-table-column>
          </el-table>

        </template>
      </el-table-column>
      <el-table-column
          label="Display"
          prop="display_name"
          sortable
          width="180">
      </el-table-column>
      <el-table-column
          label="Username"
          prop="username"
          width="180">
      </el-table-column>
      <el-table-column
          label="Profile"
          prop="profile_caption"
          width="180">
      </el-table-column>
      <el-table-column
          label="Email"
          prop="email"
          width="230">
      </el-table-column>
      <el-table-column
          label="Created"
          prop="created_at"
          width="180">
      </el-table-column>
      <el-table-column
          align="right"
          label="Actions"
          prop="">
        <template slot-scope="scope">
          <vDropdown :actionsHandler="actionsHandler" :items="usersActions" :params="{data: scope.row, rowIndex: scope.$index + 1} "
                     :userProfileId="scope.row.user_profile_id"></vDropdown>
        </template>
      </el-table-column>
    </el-table>


    <el-dialog :visible.sync="deleteDialogVisible" center title="Warning" width="420px">
      <div align="center" class="mt-2 mb-2">You want to remove this record ?</div>
      <span class="dialog-footer" slot="footer">
        <el-button @click="deleteDialogVisible = false" size="small">Cancel</el-button>
        <el-button @click="removeActionApi" size="small" type="danger">Yes</el-button>
      </span>
    </el-dialog>
  </module-list-layout>
</template>

<script>
import {mapActions, mapState} from "vuex";
import module from './../../index.js'
import toggleCell from './ag-grid/Toggle'
import actionsCell from './ag-grid/ActionsCell'
import {notify} from '@/system-services/notify'
import smartAgGridWrapper from "@/components/smart-input-view/AgGridWrapper";

export default {
  components: {
    pagination: () => import('@/components/pagination/View.vue'),
    moduleForm: () => import('../../form/View'),
    moduleListLayout: () => import('@/modules-config/layouts/list/View.vue')
  },
  computed: {
      ...mapState(module.info.name + '-state', ['openedEntity', 'pageChunkSize', 'entities']),
  },
  data() {
    return {
      tableData: [],
      amReady: false,
      deleteDialogVisible: false,
      targetParams: null,
      userSearch: '',
      userSearchTimeOut: null,
      module: {...module},
      currentPage: 1,
      editMode: false,
      dialogVisible: false,
      recordsCounter: 0,
      dataToBind: null,
      rowToEdit: null,

    };
  },
  beforeMount() {
    this.currentPage = parseInt(this.$route.params.listPage)
    this.getEntityListData(this.currentPage)
  },
  methods: {
  ...mapActions(module.info.name + '-api', {getEntityList: 'list', updateEntity: 'update', multipleDelete: "multipleDelete"}),
  getSelectedRowData() {
      let selectedNodes = this.agGrid.gridApi.getSelectedNodes();
      let selectedData = selectedNodes.map(node => node.data.id);
      this.multipleDelete({data: {ids: selectedData}}).then( r => {
        this.getEntityListData(1)
      })
  },
  updateField(customParams, newValue, afterSave, fieldName) {
      let data = {}
      data[fieldName] = newValue

      let apiParams = {
        id: customParams.data.id,
        data
      }

      this.updateEntity(apiParams).then(r => {
        afterSave()
      })
  },
  getEntityListData (page) {
    this.getEntityList({page: page, search: this.userSearch}).then(response => {
      this.buildAgGridData(response)
      this.currentPage = page
    })
  },
  buildAgGridData (response) {
    this.tableData = response.rows
    this.recordsCounter = response.count
    this.amReady = true
  },
  userSearchUpdated (field) {
      // this.agGrid.gridApi.setQuickFilter(val);
      let val = field.field.field_value
      this.userSearch = val
      clearTimeout(this.userSearchTimeOut)
      this.userSearchTimeOut = setTimeout(() => {
        this.getEntityListData(1) //this.agGrid.gridApi.setQuickFilter(val);
      }, 200)
  },
  scrollToTop () {
    document.body.scrollTop = 0;
    document.getElementById('content-main-container').scrollTop = 0;
  },
  navigateToPage (page) {
    $router.push({name : this.module.info.routeName + '->list->page', params: {listPage: page}})
    /*this.getEntityList({page: page, search: this.userSearch}).then(response => {
      this.buildAgGridData(response)
    })*/
  },
  refreshGrid() {
    this.agGrid.gridOptions.api.setRowData(this.tableData)
  },
  afterEdit(updatedData, propertyName = false, closeDialog = true) {
    // getting a rowNode by index
    // this.agGrid.gridApi.getDisplayedRowAtIndex(0).setData({})

    if (propertyName) {
      this.tableData[this.rowToEdit][propertyName] = updatedData;
    } else {
      this.tableData[this.rowToEdit] = updatedData;
    }

    if (closeDialog) this.dialogVisible = false;
    this.refreshGrid();
  },
  moduleFormDeleteAction() {
    this.removeAction({
      data: this.dataToBind,
      rowIndex: this.rowToEdit
    })
    this.dialogVisible = false;
},
  afterCreate(newEntity) {
    this.tableData.push(newEntity);
    this.dialogVisible = false;
    this.refreshGrid();
  },
  createAction(params) {
    this.dialogVisible = true;
    this.editMode = false;
    this.dataToBind = null;
    this.rowToEdit = null;
    // this.$router.push({ name: this.module.info.routeName + '->view', params: { id: params.data.id}})
  },
  editAction(params) {
    this.dialogVisible = true;
    this.editMode = true;
    this.dataToBind = params.data;
    this.rowToEdit = params.rowIndex;
  },
  removeAction(params) {
    this.targetParams = params
    this.deleteDialogVisible = true
  },
  removeActionApi () {
    let params = this.targetParams
    this.deleteDialogVisible = false
    this.$store.dispatch(this.module.info.name + '-api/remove', {id: params.data.id}).then(response => {
      this.tableData.splice(params.rowIndex, 1);
      this.refreshGrid();
      this.recordsCounter -= 1;
      notify({
        type: 'success',
        title: this.$ml.get('deleted'),
      });
    })
  },
  actionsHandler(command, params) {this[command](params)}
  }
}
</script>
